export default {
  VIDEO_PLAYER: "video_player",
  LISTING_PAGE_TILE: "listing_page_tile",
  CONTENT_HUB_HEADER: "content_hub_header",
};
